const replaceIsr = (value) => typeof value === "string"
  ? value
      .replace(/Inside Sales Representatives?\s*\(ISR\)/g, "Sales Ops")
      .replace(/Inside Sales Reps?\s*\(ISR\)/g, "Sales Ops")
      .replace(/Inside Sales Representatives?/g, "Sales Ops")
      .replace(/Inside Sales Reps?/g, "Sales Ops")
      .replace(/\bISRs\b/g, "Sales Ops")
      .replace(/\bISR\b/g, "Sales Ops")
  : value;

const normalizeNode = (node) => {
  if (node.nodeType !== 3) return;
  const next = replaceIsr(node.nodeValue);
  if (next !== node.nodeValue) node.nodeValue = next;
};

const normalizeTree = (root) => {
  if (!root) return;
  normalizeNode(root);
  const walker = document.createTreeWalker(root, 4);
  let node = walker.nextNode();
  while (node) {
    normalizeNode(node);
    node = walker.nextNode();
  }
};

const begin = () => {
  normalizeTree(document.body);
  const observer = new MutationObserver((changes) => {
    changes.forEach((change) => {
      if (change.type === "characterData") normalizeNode(change.target);
      change.addedNodes.forEach(normalizeTree);
    });
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", begin, { once: true });
} else {
  begin();
}
